import { BerthNameBM } from 'src/types/BusinessModel/Stowage/Port/BerthNameBM';
import { BerthName } from 'src/types/ViewModel/Stowage/Port/BerthName';

export const createBerthName = (berthNameBM: BerthNameBM): BerthName => {
    return {
        berthId: berthNameBM.berthId,
        portId: berthNameBM.portId,
        shortName: berthNameBM.shortName,
        longName: berthNameBM.longName,
        isDeleted: berthNameBM.isDeleted,
    };
};

export const createBerthNameList = (berthNameBMList: BerthNameBM[]) => berthNameBMList.map((berthName) => createBerthName(berthName));
